import { render, staticRenderFns } from "./CardSearch.vue?vue&type=template&id=63da8e7d&scoped=true"
import script from "./CardSearch.vue?vue&type=script&lang=js"
export * from "./CardSearch.vue?vue&type=script&lang=js"
import style0 from "./CardSearch.vue?vue&type=style&index=0&id=63da8e7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da8e7d",
  null
  
)

export default component.exports